import { Box, Button, DialogActions, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

export type MergeStepFooterProps = {
  onCancel: () => void;
  onBack?: () => void;
  /** Rendered as "Step {current} of {total}" left of BACK. Omit to hide. */
  step?: { current: number; total: number };
  /** Rendered immediately left of the step indicator (e.g. IssueListButton). */
  extras?: ReactNode;
  primary: {
    content: ReactNode;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
    testId?: string;
  };
};

export function MergeStepFooter(props: MergeStepFooterProps) {
  return (
    <DialogActions sx={{ justifyContent: "space-between", px: 3, py: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button onClick={props.onCancel} variant="text">
          CANCEL
        </Button>
      </Box>
      <Stack direction="row" spacing={2} alignItems="center">
        {props.extras}
        {props.step && (
          <Typography variant="body2" color="text.secondary">
            Step {props.step.current} of {props.step.total}
          </Typography>
        )}
        {props.onBack && (
          <Button onClick={props.onBack} variant="text" data-testid="merge-step-back">
            BACK
          </Button>
        )}
        <Button
          variant="contained"
          onClick={props.primary.onClick}
          disabled={props.primary.disabled}
          loading={props.primary.loading}
          data-testid={props.primary.testId}
        >
          {props.primary.content}
        </Button>
      </Stack>
    </DialogActions>
  );
}
